import {useCallback} from 'react';

export type PaginationEvent = { page: number; pageSize: number } | { pageSize: number } | any;

export const useVoicemailsPagination = (
  setForceFirstPage: (value: boolean) => void,
) => {
  // Trigger page change using provided getVoicemails and current filter values
  const onPageChange = useCallback(
    () => {
      setForceFirstPage(false);
    },
    [setForceFirstPage]
  );

  // Update page size and reload first page
  const onPageSizeChange = useCallback(
    () => {
      setForceFirstPage(false);
    },
    [setForceFirstPage]
  );

  return { onPageChange, onPageSizeChange };
};

